export default {
  analytics: {
    pageTitle: "Dashboard",
    subtitle: "Analítica de los eventos que afectan a tu empresa",
    loading: "Cargando analítica…",
    loadError: "No se pudo cargar la analítica.",
    kpiMonth: "Eventos este mes",
    kpiMonthSub: "últimos 30 días",
    kpiPortfolio: "En tu portfolio",
    kpiCompetitor: "En tu competencia",
    kpiTotal: "Total acumulado",
    kpiTotalSub: "desde el inicio",
    empty: "Aún no hay eventos que afecten a tu portfolio o competencia. Añade productos y competidores para empezar a ver analítica.",
    trendTitle: "Tendencia de eventos (30 días)",
    byTypeTitle: "Por bloque del catálogo (90 días)",
    seriesOwn: "Tu portfolio",
    seriesCompetitor: "Competencia",
    barHint: "Pulsa una barra para ver sus eventos",
    navBlock: "{block} · {side} · 90 días",
    navArea: "{area} · {side} · 90 días",
    byAreaTitle: "Por área terapéutica (90 días)",
    topLabsTitle: "Laboratorios más activos (90 días)",
    bySourceTitle: "Por fuente (90 días)",
    changesLabel: "eventos",
    noLabs: "Sin actividad de laboratorios en el periodo.",
    noSource: "Sin actividad por fuente en el periodo.",
    navMonth: "Eventos del último mes",
    navPortfolio: "Portfolio · último mes",
    navCompetitor: "Competencia · último mes",
    navTotal: "Todos los eventos relevantes",
  },
};
